import { RestClient } from '../utils/rest-client';
import { configService } from './config.service';
const restClient = RestClient(configService.restConfig);
async function getCrosswords({ status, }) {
    const apiResponse = await restClient.get({
        openapiPath: '/crosswords',
        queryParams: {
            status,
        },
    });
    return apiResponse.body.Data.Crosswords;
}
async function createCrossword(crossword) {
    const apiResponse = await restClient.post({
        openapiPath: '/crosswords',
        requestBody: {
            Data: crossword,
        },
    });
    return apiResponse.body.Data.Crossword;
}
async function getCrosswordDetails(crosswordId) {
    const apiResponse = await restClient.get({
        openapiPath: '/crosswords/{CrosswordId}',
        pathParams: {
            CrosswordId: crosswordId,
        },
    });
    return apiResponse.body.Data.Crossword;
}
async function updateCrossword(crosswordId, data) {
    const apiResponse = await restClient.put({
        openapiPath: '/crosswords/{CrosswordId}',
        pathParams: {
            CrosswordId: crosswordId,
        },
        requestBody: {
            Data: data,
        },
    });
    return apiResponse.body.Data.Crossword;
}
async function deleteCrossword(crosswordId) {
    const apiResponse = await restClient.delete({
        openapiPath: '/crosswords/{CrosswordId}',
        pathParams: {
            CrosswordId: crosswordId,
        },
    });
    return { crosswordId };
}
async function updateCrosswordStatus(crosswordId, status) {
    const apiResponse = await restClient.put({
        openapiPath: '/crosswords/{CrosswordId}/status',
        pathParams: {
            CrosswordId: crosswordId,
        },
        requestBody: {
            Data: { status },
        },
    });
    return { ...apiResponse.body.Data.Crossword, crosswordId };
}
async function updateWords(crosswordId, words, seed) {
    const apiResponse = await restClient.put({
        openapiPath: '/crosswords/{CrosswordId}/words',
        pathParams: {
            CrosswordId: crosswordId,
        },
        requestBody: {
            Data: { words, seed },
        },
    });
    return {
        crosswordId,
        words: [...apiResponse.body.Data.words],
        seed: apiResponse.body.Data.seed,
    };
}
async function getSubmissions(crosswordId) {
    const apiResponse = await restClient.get({
        openapiPath: '/crosswords/{CrosswordId}/submissions',
        pathParams: {
            CrosswordId: crosswordId,
        },
    });
    return apiResponse.body.Data.Submissions;
}
const crosswordService = {
    getCrosswords,
    createCrossword,
    getCrosswordDetails,
    updateCrossword,
    deleteCrossword,
    updateCrosswordStatus,
    updateWords,
    getSubmissions,
};
export { crosswordService };
